export const PAYMENT_STATUS = [
  "PENDING",
  "PAID",
  "CANCELLED",
  "FAILURE",
  "REVERSED",
  "INPROGRESS",
];
